import {useState} from "react";
import Filter from "./features/Filter";
import TabNav from "./features/TabNav";
import Tab2 from "./features/Tab2";
import Tab1 from "./features/Tab1";
import {salesSearchParamInit, salesYearlyMapInit} from "./state";
import {
    SalesRevenueByCompanyAllMapType,
    SalesRevenueByCompanyAllType,
    SalesRevenueViewInfoElementType,
    SalesSearchParamType
} from "./interface";
import {useReadYearlyRevenue} from "./hooks/useReadYearlyRevenue";
import {useForm, useWatch} from "react-hook-form";
import {useUpdateRevenue} from "./hooks/useUpdateRevenue";
import {useReadAllRevenueByCompany} from "./hooks/useReadAllRevenueByCompany";
import {useModal} from "../../../../hooks";
import moment from "moment/moment";

export default function SalesList() {
    const {handleModal} = useModal();
    const [searchParam, setSearchParam] = useState<SalesSearchParamType>((() => ({
        ...salesSearchParamInit,
        revenueMonth: moment().month() + 1,
        revenueYear: moment().year(),
    }))());
    const [tab, setTab] = useState<number>(2);
    const [isModify, setIsModify] = useState<boolean>(false)

    const {data: yearlyRevenueData} = useReadYearlyRevenue({param: searchParam, enabled: tab === 1})
    const yearlyRevenue = yearlyRevenueData ?? salesYearlyMapInit

    const {data: revenueAllByCompany} = useReadAllRevenueByCompany({
        param: searchParam,
        enabled: tab === 2
    })

    const dataList: SalesRevenueByCompanyAllType[] = revenueAllByCompany?.searchAllRevenueResList ?? []
    const hiddenColumnData: SalesRevenueViewInfoElementType[] = revenueAllByCompany?.revenueViewInfoVOList ?? []

    const {
        register: registerMod,
        handleSubmit: handleSubmitMod,
        getValues: getValuesMod,
        setValue: setValueMod,
        watch: watchMod,
        reset: resetMod,
        control: controlMod
    } = useForm({
        defaultValues: revenueAllByCompany
    });

    const modifyData = {
        ...revenueAllByCompany,
        ...useWatch<SalesRevenueByCompanyAllMapType>({control: controlMod}),
    } as SalesRevenueByCompanyAllMapType

    const toggleIsModify = () => {
        if (!isModify && searchParam.revenueMonth == 0) {
            handleModal({
                isOpen: true,
                contents: "월별 수정만 가능합니다.",
                type: "alert"
            })
        } else {
            if (isModify) {
                setIsModify(false)
                resetMod()
            } else {
                setIsModify(true)
                setValueMod("searchAllRevenueResList", revenueAllByCompany.searchAllRevenueResList)
            }
        }
    }

    const {mutate: mutateUpdateRevenue} = useUpdateRevenue({closeCallback: () => setIsModify(false)})
    const btnModifySave = () => {
        // const transformedList = modifyData.searchAllRevenueResList.flatMap(({revenueDataMapList, ...rest}) =>
        //     revenueDataMapList.filter(el => el.month == searchParam.revenueMonth).map(({month, revenueData}) => ({
        //         ...rest,
        //         month,
        //         revenueGoal: revenueData.revenueGoal,
        //         estimatedRevenue: revenueData.estimatedRevenue,
        //         actualRevenue: revenueData.actualRevenue,
        //     }))
        // );

        const transformedList = modifyData.searchAllRevenueResList.flatMap(({revenueDataMapList, ...rest}) => {
            return revenueDataMapList.filter(el => el.month == searchParam.revenueMonth).map((item: any) => ({
                revenueMonth: item.month,
                revenueYear: searchParam.revenueYear,
                revenueId: item.revenueId,
                revenueGoal: item.revenueData.revenueGoal,
                estimatedRevenue: item.revenueData.estimatedRevenue,
                actualRevenue: item.revenueData.actualRevenue,
                revenueErpAccountId: rest.revenueErpAccountId,
                newProductGroupid: rest.newProductGroupid,
                customerAccountsId: rest.customerAccountsId,
                shipErpAccountId: rest.shipErpAccountId,
                handlerId: rest.handlerId,
            }))
        })

        console.log(transformedList)
        mutateUpdateRevenue(transformedList)
    }

    return (
        <>
            <Filter searchParam={searchParam} setSearchParam={setSearchParam} tab={tab}
                    isModify={isModify}
                    btnModifySave={btnModifySave}
                    toggleIsModify={toggleIsModify}/>

            <TabNav tab={tab} setTab={setTab} isModify={isModify}/>

            {tab === 1 && <Tab1 yearlyRevenue={yearlyRevenue} searchParam={searchParam}/>}

            {tab === 2 && <Tab2 searchParam={searchParam}
                                dataList={dataList}
                                hiddenColumnData={hiddenColumnData}
                                isEdit={isModify}
                                editData={modifyData}
                                register={registerMod}
                                monthView={searchParam.revenueMonth == 0 ? "filtered" : "one"}
                                control={controlMod}/>}
        </>
    );
}